<script>
import dialog2Mixin from '../mixins/dialog2'
import HotelMemberOrderBilling from '@components/HotelMember/HotelMemberOrderBilling.vue'

export default {
  name: 'DialogHotelOrderDetails',
  components: {
    HotelMemberOrderBilling,
  },
  mixins: [dialog2Mixin],
  data() {
    return {
      containerItem: {},
    }
  },
  watch: {
    '$route.fullPath'() {
      this.dialog2MixinVisible = false
    },
  },
}
</script>

<template>
  <el-dialog
    :visible.sync="dialog2MixinVisible"
    width="786px"
    append-to-body
    :custom-class="`${$style.dialogHotelOrderDetails} isStyleBase`"
    @closed="$Dialog2MixinOnDestroy"
  >
    <div :class="$style.title">
      訂單明細
    </div>
    <div class="mt-4">
      <HotelMemberOrderBilling
        v-if="containerItem && containerItem.orders && containerItem.orders.items"
        :container-item="containerItem"
        compact
      />
    </div>
  </el-dialog>
</template>

<style lang="scss" module>
.dialogHotelOrderDetails {
  @include max-lg {
    width: 75%;
  }
}

.title {
  text-align: center;
  margin-bottom: 0.5rem;
  font-family: $font-title;
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 1.5;
  color: $color-primary-dark;
}
</style>
